import * as React from 'react';
import { useEffect, useState } from "react";

import './semaphore.css';

interface SemaphoreProps {
    value: number | null
    population?: string
}

export const Semaphore: React.FC<SemaphoreProps> = (props) => {

    const [selectedStatus, setSelectedStatus] = useState<string | null>(null);

    function getStatusFromValue(value : number, population?: string) {
        if (population === 'control') {
          if (value <= 0.25) return 'red';
          if (value <= 0.50) return 'orange';
          if (value <= 0.75) return 'yellow';
          return 'green';
        }

        if (value <= 0.25) return 'green';
        if (value <= 0.50) return 'yellow';
        if (value <= 0.75) return 'orange';
        return 'red';
      }

    useEffect(() => {
      if (props.value !== null) {
        setSelectedStatus(getStatusFromValue(props.value, props.population));
      } else {
        setSelectedStatus(null);
      }
    }, [props.value, props.population]);

    if (selectedStatus === null) {
      return null
    };

    return <span className={`semaphore-dot ${selectedStatus}`} title={selectedStatus} />;
}
